import SubscriptionPricingSection from "./SubscriptionPricingSection";

export default SubscriptionPricingSection;
